import React from "react";
import {
  Person as PersonIcon,
  Security as SecurityIcon,
  AccountBalance as AccountBalanceIcon,
} from "@mui/icons-material";

export const settingsMenuItems = [
  {
    label: "Profile",
    icon: <PersonIcon fontSize="small" />,
    path: "/settings?tab=profile",
  },

  {
    label: "Security",
    icon: <SecurityIcon fontSize="small" />,
    path: "/settings?tab=security",
  },
  {
    label: "Finances",
    icon: <AccountBalanceIcon fontSize="small" />,
    path: "/settings?tab=finances",
  },
];
